// src/components/programs/ProgramForm/Step1Sections/ProductsPanel/ProductsList.jsx

import React from "react";
import { Grid, Box, Typography, alpha, useTheme } from "@mui/material";
import { Inventory2Outlined as EmptyIcon } from "@mui/icons-material";
import ProductCard from "./ProductCard";

const ProductsList = ({
    products,
    isArabic,
    activeLang,
    isFetching,
}) => {
    const theme = useTheme();

    if (!products || products.length === 0) {
        return (
            <Box
                sx={{
                    textAlign: 'center',
                    py: 4,
                    px: 2,
                    borderRadius: 2,
                    bgcolor: alpha(theme.palette.action.hover, 0.2),
                    border: `1px dashed ${alpha(theme.palette.divider, 0.5)}`,
                }}
            >
                <EmptyIcon sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
                <Typography variant="body2" color="text.secondary" fontWeight={500}>
                    {isArabic ? 'لا توجد منتجات' : 'No products found'}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                    {isArabic ? 'جرب تغيير الفلاتر' : 'Try changing filters'}
                </Typography>
            </Box>
        );
    }

    return (
        <Grid 
            container 
            spacing={1} 
            sx={{ 
                opacity: isFetching ? 0.6 : 1, 
                transition: 'opacity 0.3s',
                position: 'relative',
            }}
        >
            {products.map((product) => (
                <Grid item xs={12} key={product.id}>
                    <ProductCard
                        product={product}
                        isArabic={isArabic}
                        activeLang={activeLang}
                    />
                </Grid>
            ))}
        </Grid>
    );
};

export default ProductsList;
